import { THEME_SPACINGS } from '../spacings/types';
import { PREFIX } from '../constants';

export function getSpace(spacing: keyof THEME_SPACINGS) {
  return `var(${PREFIX.SPACING}${spacing})`;
}
